// extracted by mini-css-extract-plugin
export default {"success-wrap":"AddAQuestionForm_success-wrap__RIOXs","add-quest-form":"AddAQuestionForm_add-quest-form__0p69e"};